// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testAttributeCodeCode } from './TestAttributeCode';
import { z } from 'zod';
export const testAttributeCodeRowKeyId = (z.number());
export const testAttributeCodeRowKey = z.object({
    id: testAttributeCodeRowKeyId,
    attribute_code: testAttributeCodeCode,
    key: z.string(),
    name: z.string(),
    sort_order: z.number(),
    archived_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const testAttributeCodeRowKeyInitializer = z.object({
    id: testAttributeCodeRowKeyId.optional(),
    attribute_code: testAttributeCodeCode,
    key: z.string(),
    name: z.string(),
    sort_order: z.number().optional(),
    archived_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const testAttributeCodeRowKeyMutator = z.object({
    id: testAttributeCodeRowKeyId.optional(),
    attribute_code: testAttributeCodeCode.optional(),
    key: z.string().optional(),
    name: z.string().optional(),
    sort_order: z.number().optional(),
    archived_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=TestAttributeCodeRowKey.js.map